import { render, staticRenderFns } from "./BaseTLhtmlEditor.vue?vue&type=template&id=734cb490&scoped=true&"
import script from "./BaseTLhtmlEditor.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BaseTLhtmlEditor.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BaseTLhtmlEditor.vue?vue&type=style&index=0&id=734cb490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734cb490",
  null
  
)

export default component.exports